import React from "react";
export default function IntroNoticeBox() {
  return <section data-section-id="255854" id="intro-notice-box" className="w-full py-12 bg-background text-foreground">
      <div className="container mx-auto px-4 flex flex-col items-center justify-center">
        <div className="w-full max-w-[800px] p-8 bg-secondary/10 border border-secondary rounded-lg flex items-center justify-start relative overflow-hidden border-l-[4px] border-l-secondary shadow-md">
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0 mt-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-secondary">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
            </div>
            <div className="flex flex-col gap-2">
              <h2 className="text-xl font-default font-bold text-foreground tracking-tight">
                Important Notice
              </h2>
              <p className="text-sm font-default text-muted-foreground leading-relaxed">
                By submitting a deposit or any payment to BlinkLab Media, you acknowledge that you have read, understood, and agreed to these Terms of Service in full. These terms apply to all web design, social media, digital marketing, and maintenance services provided by BlinkLab Media, a division of BL Events LLC.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}